import { FieldErrorWrapper } from 'components/Blocks';
import { Controller, useFormContext, ControllerProps, Path } from 'react-hook-form';
import { AnyObject, StableOmit } from 'types';

export interface FormControllerProps<T extends AnyObject, Prop extends keyof T>
  extends StableOmit<
    ControllerProps<T, Prop extends Path<T> ? Prop : Path<T>>,
    'control' | 'name'
  > {
  property: Prop;

  /**
   * Automatically adds the error on screen
   */
  handleError?: boolean;
}

export function FormController<T extends AnyObject, Prop extends keyof T>({
  property,
  handleError = false,
  render,
  ...props
}: FormControllerProps<T, Prop>) {
  const { control } = useFormContext<T>();

  const withError: false | FormControllerProps<T, Prop>['render'] =
    handleError &&
    ((params) => (
      <FieldErrorWrapper error={params.fieldState.error}>{render(params)}</FieldErrorWrapper>
    ));

  return (
    <Controller
      // we know this works because of the interface definition above
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      control={control as any}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      name={property as any}
      render={withError || render}
      {...props}
    />
  );
}
